import React, { useContext, useEffect, useRef, useState } from "react";
import { getImages } from '../Common/const'
import ContactForm from "../Common/ContactForm";
import { Link } from "react-router-dom";
import SeoMeta from "../Common/SeoMeta";
import { VehicleContext } from "../Context/VehicleContext";

const About = () => {
      const { getCMSData } = useContext(VehicleContext);
      const [cmsData, setCMSData] = useState({});
      const getPageData = async () => {
        setCMSData(await getCMSData('about'));
      }
      useEffect(() => {
        getPageData();
      }, []);
      const getCMSValue = (field) => {
        return field in cmsData ? cmsData[field] : "";
      }
      const sectionRef = useRef(null);
      const scrollToSection = () => {
          sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      };
  return (
    <>
      <SeoMeta
        title="About European Exotic Center in Tampa, FL and San Clemente, CA"
        description="Learn more about European Exotic Center, a car dealership in Tampa, FL and San Clemente, CA committed to providing long term satisfaction to our customers."
        keywords=""
        ogTitle="About European Exotic Center in Tampa, FL and San Clemente, CA"
        ogDescription="Learn more about European Exotic Center, a car dealership in Tampa, FL and San Clemente, CA committed to providing long term satisfaction to our customers."
      />
      <section className='contact-wrap pt-165'>
        <h1 className='lg-title text-center text-uppercase font-3em mb-4 wow reveal fadeInUp'><span className='text-orange'>Two</span> Incredible Locations</h1>
        <div className='container'>
          <div className='contact-hero-map text-center wow reveal fadeIn  pt-4 pb-5'>
            <img src={getImages('contact-bg.png')} />
          </div>
          <div className="service-center-box wow reveal fadeIn" 
            style={{
              background: `#181616 url(${getImages('side-bg.png')}`
            }}
          >
            <div className="w-100 scb-content">
              <div className="d-flex align-items-center mb-4">
                <div className="me-xl-3 me-2">
                  <img className="location-icon" alt="location" src={getImages('location-icon.png')} />
                </div>
                <div className="md-title">Tampa, FL</div>
              </div>
              <div className="xxl-title mb-3 font-3em text-start text-uppercase fw-700 wow reveal fadeInUp">{getCMSValue('aboutServiceMainHeading')}</div>
              <div className="lg-title font-2-4em wow reveal fadeInUp">{getCMSValue('aboutServiceSubHeading')}</div>
              <div className="mt-3 wow reveal fadeInUp">
                <button type="button" onClick={scrollToSection} className="orange-white-btn fw-700 text-uppercase d-inline-block">Schedule Service</button>
              </div>
            </div>
          </div>
          <h1 className='lg-title font-2-5em mb-3 wow reveal fadeInUp'>{getCMSValue('ContentMainHeading')}</h1>
          <h2 className='lg-title font-1-9em mb-4 text-orange text-uppercase wow reveal fadeInUp'>{getCMSValue('ContentSubHeading')}</h2>
          <div className='common-text mb-5  wow reveal fadeInUp'>
            <p>{getCMSValue('ContentText')}</p>
          </div>
          <div className="row mlr-60 cu-map-block">
            <div className="col-lg-6 wow reveal fadeInLeft">
                <iframe src="https://snazzymaps.com/embed/739247" width="100%" height="340px" style={{border:'none'}}></iframe>

              <div className="d-flex align-items-center mt-4">
                <div className="me-xl-3 me-2">
                  <img className="location-icon" alt="location" src={getImages('location-icon.png')} />
                </div>
                <div className="md-title">{getCMSValue('aboutLocation1Name')}</div>
              </div>
              <div className="xs-title font-1-1em mt-3 mb-md-2 mb-3">{getCMSValue('aboutLocation1Address')}</div>
              <div><a href="https://maps.app.goo.gl/8opCErm85YUk63Bj9" target="_blank" className="xs-title font-13 text-orange fw-500 avenir-next d-inline-block">Get Directions</a></div>
              <div className='xs-title'>
                <div className='row mt-3'>
                  <div className='col-5 avenir-next opacity-0-5'>Sales</div>
                  <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> {getCMSValue('aboutLocation1Sales')}</div>
                </div>
                <div className='row mt-3'>
                  <div className='col-5 avenir-next opacity-0-5'>Service</div>
                  <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> {getCMSValue('aboutLocation1Service')}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow reveal fadeInRight">
                <iframe src="https://snazzymaps.com/embed/739251" width="100%" height="340px" style={{border:'none'}}></iframe>
              <div className="d-flex align-items-center mt-4">
                <div className="me-xl-3 me-2">
                  <img className="location-icon" alt="location" src={getImages('location-icon.png')} />
                </div>
                <div className="md-title">{getCMSValue('aboutLocation2Name')}</div>
              </div>
              <div className="xs-title font-1-1em mt-3 mb-md-2 mb-3">{getCMSValue('aboutLocation2Address')}</div>
              <div><a href="https://maps.app.goo.gl/KAV1PEzJXLbZAp8a8" target="_blank" className="xs-title font-13 text-orange fw-500 avenir-next d-inline-block">Get Directions</a></div>
              <div className='xs-title'>
                <div className='row mt-3'>
                  <div className='col-5 avenir-next opacity-0-5'>Sales</div>
                  <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> {getCMSValue('aboutLocation2Sales')}</div>
                </div>
                {getCMSValue('aboutLocation2Service') && (
                  <div className='row mt-3'>
                    <div className='col-5 avenir-next opacity-0-5'>Service</div>
                    <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> {getCMSValue('aboutLocation2Service')}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='mt-70 cu-content-block'>
            <div className='row mlr-60'>
              <div className='col-md-6 wow reveal fadeInLeft'>
                <div className='lg-title text-uppercase font-1-9em mb-4'>{getCMSValue('aboutCard1Title')}</div>
                <div className='common-text'>
                  <p>{getCMSValue('aboutCard1Text')}</p>
                </div>
              </div>
              <div className='col-md-6 wow reveal fadeInRight'>
                <div className='lg-title text-uppercase font-1-9em mb-4'>{getCMSValue('aboutCard2Title')}</div>
                <div className='common-text'>
                  <p>{getCMSValue('aboutCard2Text')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='custom-form contactus-form' ref={sectionRef}>
            <div className='lg-title text-uppercase mb-4 wow reveal fadeInUp'>Ask A Question</div>
            <ContactForm/>
          </div>
        </div>
      </section>

    </>
  )
}

export default About